export default __webpack_public_path__ + "static/images/account.c67de831.png";